@if ($any(demoBtnVisibilityCount$ | async) < 5) {
<div class="por consumer-login" id="apx">
    <div class="consumer-login-container">
        @switch (activeView$ | async) { @case ('CustomerSelection') {
        <ng-container [ngTemplateOutlet]="customerSelection"></ng-container>
        } @default {
        <ng-container [ngTemplateOutlet]="login"></ng-container>
        } } @if (showLoader) {
        <por-loader></por-loader>
        }
    </div>
</div>
} @else {
<por-consumer-portal-demo></por-consumer-portal-demo>
}

<ng-template #login>
    <div class="main">
        @if (isLogoDisplayed()) {
        <img class="consumer-login-logo" [src]="inputs?.logoUrl" (click)="onLogoClick()" />
        } @else {
        <span class="consumer-login-logo depot-name" (click)="onLogoClick()">{{ inputs?.depotName }}</span>
        } @if (showAlert) {
        <por-alert [alertMessage]="alertMessage"></por-alert>
        }
        <div class="login-wrap">
            @switch (selectedTemplate) { @case ('signin') {
            <por-signin
                (selectedTemplate)="activeTemplate($event)"
                (loginData)="handleLoginData($event)"
                [config]="config"
                [isDisableButton]="isDisableButton"
                [quickLinkUrl]="quickLinkUrl"></por-signin>
            } @case ('signup') {
            <por-signup (selectedTemplate)="activeTemplate($event)" (signupData)="handleSignupData($event)" [config]="config" [isDisableButton]="isDisableButton"></por-signup>
            } @case ('verify') {
            <por-verify
                (selectedTemplate)="activeTemplate($event)"
                (verificationData)="handleVerificationData($event)"
                [config]="config"
                [isDisableButton]="isDisableButton"
                [userEmail]="userEmail"></por-verify>
            } @case ('forgot-password') {
            <por-forgot-password
                (selectedTemplate)="activeTemplate($event)"
                (forgotPasswordData)="handleForgotPasswordData($event)"
                [config]="config"
                [isDisableButton]="isDisableButton"></por-forgot-password>
            } @case ('change-password') {
            <por-change-password
                (selectedTemplate)="activeTemplate($event)"
                (changePasswordData)="handleChangePasswordData($event)"
                [isUserDisabled]="isUserDisabled"
                [config]="config"
                [isDisableButton]="isDisableButton"
                [userEmail]="userEmail"></por-change-password>
            } @case ('busy-indicator') {
            <por-busy-indicator (selectedTemplate)="activeTemplate($event)" [config]="config"></por-busy-indicator>
            } @case ('configError') {
            <por-alert [alertMessage]="'InvalidSubDomainOrgId' | translate"></por-alert>
            } }
        </div>
        @if (showAdvanceNotation()) {
        <div class="adv-notation">
            <span>ADV</span>
        </div>
        }
    </div>
</ng-template>
<ng-template #customerSelection>
    <por-customer-selection [contacts]="userAccounts || []" [selectedContact]="selectedContact" (contactSelected)="setContact($event)"></por-customer-selection>
</ng-template>
